"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Filters = _interopRequireDefault(require("./common/Filters"));

var _Loading = _interopRequireDefault(require("./common/Loading"));

var _apis = require("../services/apis");

var _snackbarStatus = require("../constants/snackbarStatus");

var _snackbar = require("../actions/snackbar");

var _filters = require("../constants/filters");

var _reactRedux = require("react-redux");

var _view = require("../constants/view");

var _environment = require("../constants/environment");

var _helpers = require("../services/helpers");

var _useSavedSearch2 = _interopRequireDefault(require("../customHooks/useSavedSearch"));

var _dashboardConfig = require("../constants/dashboardConfig");

var _userAttributes = require("../constants/userAttributes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Performance(_ref) {
  var accessToken = _ref.accessToken,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? _environment.ENVIRONMENT.PRODUCTION : _ref$environment,
      showSnackbar = _ref.showSnackbar,
      _ref$fulfiller = _ref.fulfiller;
  _ref$fulfiller = _ref$fulfiller === void 0 ? {} : _ref$fulfiller;
  var fulfillerId = _ref$fulfiller.fulfillerId,
      fulfillerName = _ref$fulfiller.name,
      filters = _ref.filters,
      onChangeFilters = _ref.onChangeFilters,
      _ref$view = _ref.view,
      view = _ref$view === void 0 ? _view.COMPONENT_VIEW.NETWORK : _ref$view,
      _ref$filterPrecedence = _ref.filterPrecedence,
      filterPrecedence = _ref$filterPrecedence === void 0 ? _filters.FILTER_PRECEDENCE.DEFAULT : _ref$filterPrecedence,
      _ref$hideHeading = _ref.hideHeading,
      hideHeading = _ref$hideHeading === void 0 ? false : _ref$hideHeading,
      _ref$hideFilters = _ref.hideFilters,
      hideFilters = _ref$hideFilters === void 0 ? false : _ref$hideFilters,
      _ref$componentHeight = _ref.componentHeight,
      componentHeight = _ref$componentHeight === void 0 ? 'calc(100vh - 90px)' : _ref$componentHeight;

  var validateViewParams = function validateViewParams() {
    // if fulfiller not passed for fulfiller views OR its passed for network view then error
    // eror boundary will catch these errors
    if (view !== _view.COMPONENT_VIEW.NETWORK && !(fulfillerId && fulfillerName)) {
      throw new Error('Invalid Arguments: fulfiller must be passed for fulfiller view!');
    }

    if (view === _view.COMPONENT_VIEW.NETWORK && (fulfillerId || fulfillerName)) {
      throw new Error('Invalid Arguments: fulfiller cannot be passed for network view!');
    }
  };

  validateViewParams();

  var getDashboardConfiguration = function getDashboardConfiguration(view) {
    // configuration Id obtained after registering looker dashboard with NALA api
    switch (view) {
      case _view.COMPONENT_VIEW.FULFILLER:
        {
          var _userAttributeValues;

          // return fulfiller view dashboard
          return {
            configurationId: _dashboardConfig.FULFILLER_VIEW,
            //dashboards 9433
            userAttributeValues: (_userAttributeValues = {}, (0, _defineProperty2["default"])(_userAttributeValues, _userAttributes.MCP_ALLOWED_FULFILLERS, [fulfillerId]), (0, _defineProperty2["default"])(_userAttributeValues, _userAttributes.FULFILLERS_READ_PRICE, [fulfillerId]), _userAttributeValues)
          };
        }

      case _view.COMPONENT_VIEW.MERCHANT_FULFILLER:
        {
          var _userAttributeValues2;

          // return merchant's - fulfiller view dashboard
          return {
            configurationId: _dashboardConfig.MERCHANT_FULFILLER_VIEW,
            //dashboards 10400
            userAttributeValues: (_userAttributeValues2 = {}, (0, _defineProperty2["default"])(_userAttributeValues2, _userAttributes.MCP_ALLOWED_MERCHANTS, ['*']), (0, _defineProperty2["default"])(_userAttributeValues2, _userAttributes.MERCHANTS_READ_PRICE, ['*']), (0, _defineProperty2["default"])(_userAttributeValues2, _userAttributes.FULFILLERS_READ_PRICE, [fulfillerId]), _userAttributeValues2)
          };
        }

      default:
        {
          // return network view dashboard
          return {
            configurationId: _dashboardConfig.NETWORK_VIEW // dashboard 8871

          };
        }
    }
  };

  var _getDashboardConfigur = getDashboardConfiguration(view),
      configurationId = _getDashboardConfigur.configurationId,
      _getDashboardConfigur2 = _getDashboardConfigur.userAttributeValues,
      userAttributeValues = _getDashboardConfigur2 === void 0 ? {} : _getDashboardConfigur2;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      extraLoading = _useState4[0],
      setExtraLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      performanceDashboardUrl = _useState6[0],
      setPerformanceDashboardUrl = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      showFilters = _useState8[0],
      setShowFilters = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      selectedFilters = _useState10[0],
      setSelectedFilters = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      selectedSearch = _useState12[0],
      setSelectedSearch = _useState12[1];

  var _useSavedSearch = (0, _useSavedSearch2["default"])({
    fulfillerId: fulfillerId,
    fulfillerName: fulfillerName,
    externalFilters: filters,
    filterPrecedence: filterPrecedence,
    showSnackbar: showSnackbar,
    accessToken: accessToken
  }),
      defaultFilters = _useSavedSearch.defaultFilters,
      savedSearchToApply = _useSavedSearch.savedSearchToApply,
      isLoading = _useSavedSearch.isLoading;

  (0, _react.useEffect)(function () {
    if (!isLoading) {
      setSelectedFilters(defaultFilters);
      setSelectedSearch(savedSearchToApply);
    }
  }, [isLoading, defaultFilters, savedSearchToApply]);

  var applyFilters = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(updatedFilters) {
      var filtersToReturn;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSelectedFilters(updatedFilters);
              setShowFilters(false);

              if (onChangeFilters && view === _view.COMPONENT_VIEW.NETWORK) {
                filtersToReturn = _objectSpread(_objectSpread({}, updatedFilters[_filters.FULFILLER.name] ? (0, _defineProperty2["default"])({}, _filters.FILTER_NAMES.FULFILLER, updatedFilters[_filters.FULFILLER.name].map(function (_ref3) {
                  var id = _ref3.id,
                      label = _ref3.label;
                  return {
                    fulfillerId: id,
                    name: label
                  };
                })) : {}), updatedFilters[_filters.MERCHANT.name] ? (0, _defineProperty2["default"])({}, _filters.FILTER_NAMES.MERCHANT, updatedFilters[_filters.MERCHANT.name].map(function (_ref5) {
                  var id = _ref5.id,
                      label = _ref5.label;
                  return {
                    merchantId: id,
                    displayName: label
                  };
                })) : {});
                onChangeFilters(filtersToReturn);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function applyFilters(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var cancelFilters = function cancelFilters() {
    return setShowFilters(false);
  }; // adds or removes userAttributes & their values on given VIEWS.


  var getUserAttributeValues = function getUserAttributeValues(_ref7) {
    var filtersToApply = _ref7.filtersToApply,
        userAttributeValues = _ref7.userAttributeValues,
        configurationId = _ref7.configurationId;

    if (configurationId === _dashboardConfig.NETWORK_VIEW) {
      var _ref8 = filtersToApply.find(function (e) {
        return e.filter === _filters.MERCHANT.name;
      }) || {},
          _ref8$filterValue = _ref8.filterValue,
          filterValue = _ref8$filterValue === void 0 ? '' : _ref8$filterValue;

      userAttributeValues[_userAttributes.MCP_ALLOWED_MERCHANTS] = filterValue.length ? filterValue.split(',') : ['*'];
      userAttributeValues[_userAttributes.MERCHANTS_READ_PRICE] = filterValue.length ? filterValue.split(',') : ['*']; // fulfillers read price could be reduced more

      userAttributeValues[_userAttributes.FULFILLERS_READ_PRICE] = ['*'];
    }

    return userAttributeValues;
  };

  (0, _react.useEffect)(function () {
    var formatFiltersData = function formatFiltersData(selectedFilters) {
      var filters = Object.keys(selectedFilters).map(function (key) {
        var currentFilter = selectedFilters[key] || [];
        currentFilter = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
        var values = currentFilter.map(function (_ref9) {
          var value = _ref9.value;
          return key === _filters.FILTER_NAMES.PRODUCT_CATEGORY ? encodeURIComponent("%".concat(value, "%")) : value;
        }).flat();
        return {
          filter: key,
          filterValue: values.join(',')
        };
      });
      return filters;
    };

    function getDashboardUrl() {
      return _getDashboardUrl.apply(this, arguments);
    }

    function _getDashboardUrl() {
      _getDashboardUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var referenceDate, filtersToApply, _yield$getLookerDashb, signedEmbedUrl, _error$response;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoading(true);
                referenceDate = (0, _helpers.getReferenceDate)();
                filtersToApply = formatFiltersData(_objectSpread(_objectSpread({}, selectedFilters), {}, (0, _defineProperty2["default"])({}, _filters.REFERENCE_DATE.name, {
                  label: referenceDate,
                  value: referenceDate
                })));
                _context2.prev = 3;
                _context2.next = 6;
                return (0, _apis.getLookerDashboardUrl)({
                  environment: environment,
                  accessToken: accessToken
                }, {
                  configurationId: configurationId,
                  filters: filtersToApply,
                  userAttributeValues: getUserAttributeValues({
                    filtersToApply: filtersToApply,
                    userAttributeValues: userAttributeValues,
                    configurationId: configurationId
                  })
                });

              case 6:
                _yield$getLookerDashb = _context2.sent;
                signedEmbedUrl = _yield$getLookerDashb.signedEmbedUrl;
                setPerformanceDashboardUrl(signedEmbedUrl || '');
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                console.error((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.response) || _context2.t0);
                showSnackbar({
                  status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
                  message: 'Error while fetching the dashboard! Please try reloading.'
                });

              case 15:
                setLoading(false); // additional loader for covering up looker's time to load

                setExtraLoading(true);
                setTimeout(function () {
                  setExtraLoading(false);
                }, 4000);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 11]]);
      }));
      return _getDashboardUrl.apply(this, arguments);
    }

    if (selectedFilters) getDashboardUrl();
  }, [selectedFilters, configurationId, showSnackbar]);
  return loading || isLoading ? /*#__PURE__*/_react["default"].createElement(_Loading["default"], null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-parent-center"
  }, !hideHeading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "main-heading"
  }, "Performance Overview ".concat(fulfillerId ? "- ".concat(fulfillerName, " ") : '').concat(selectedSearch !== null && selectedSearch !== void 0 && selectedSearch.label ? "(".concat(selectedSearch.label, ")") : '')), !hideFilters && !extraLoading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "filters-link",
    onClick: function onClick() {
      return setShowFilters(true);
    }
  }, "Filters"), /*#__PURE__*/_react["default"].createElement(_Filters["default"], {
    environment: environment,
    accessToken: accessToken,
    fulfiller: {
      fulfillerId: fulfillerId,
      name: fulfillerName
    },
    filterList: view === _view.COMPONENT_VIEW.NETWORK ? [_filters.FILTER_NAMES.MERCHANT, _filters.FILTER_NAMES.FULFILLER, _filters.FILTER_NAMES.CURRENCY, _filters.FILTER_NAMES.TIME_FRAME, _filters.FILTER_NAMES.FULFILLMENT_LOCATION, _filters.FILTER_NAMES.PRODUCT_CATEGORY] : [_filters.FILTER_NAMES.CURRENCY, _filters.FILTER_NAMES.TIME_FRAME, _filters.FILTER_NAMES.FULFILLMENT_LOCATION, _filters.FILTER_NAMES.PRODUCT_CATEGORY],
    externalFilters: filters,
    show: showFilters,
    onApplyFilters: applyFilters,
    onCancelFilters: cancelFilters,
    onChangeSelectedSearch: setSelectedSearch,
    filterPrecedence: filterPrecedence,
    selectedFilters: selectedFilters,
    selectedSearch: selectedSearch
  }))), /*#__PURE__*/_react["default"].createElement("div", null, extraLoading ? /*#__PURE__*/_react["default"].createElement(_Loading["default"], null) : /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("iframe", {
    id: "performanceIframe",
    title: "Performance Dashboard",
    src: performanceDashboardUrl,
    width: "100%",
    frameBorder: "0",
    style: componentHeight ? {
      height: componentHeight
    } : {}
  })));
}

var _default = (0, _reactRedux.connect)(null, {
  showSnackbar: _snackbar.showSnackbar
})(Performance);

exports["default"] = _default;